import { AuthInfo} from "../models/auth";

const getProfileData = (): AuthInfo | null => {
  let authHeader: any

   authHeader = window.localStorage.getItem('anyplayPreview')

  if (authHeader) {
    if (authHeader !== '') {
      return JSON.parse(authHeader) as AuthInfo;
    }
    return null;
  }
  return null;
};


const setProfileData = (authData: AuthInfo): void => {
  console.log('setProfileData -> authData', authData)
   window.localStorage.setItem('anyplayPreview',JSON.stringify(authData))
};

const removeProfileData = (): void => {
  window.localStorage.removeItem('anyplayPreview');
};

export { getProfileData, setProfileData, removeProfileData };
